export class EmptySnakeLayoutNode {}
